import React from 'react';

const PostsStatusMessages = ({ 
    loading, 
    hasMore, 
    displayPosts, 
    selectedCategory 
}) => (
    <>
        {/* Loading indicator */}
        {loading && (
            <div className="text-center mt-4">
                <div className="spinner-border text-dark loading-spinner" role="status">
                    <span className="visually-hidden">جاري التحميل...</span>
                </div>
                <p className="mt-2 text-muted">جاري تحميل المقالات ...</p>
            </div>
        )}
        
        {/* No more posts message */}
        {!hasMore && displayPosts && displayPosts.length > 0 && (
            <div className="text-center mt-4 p-3 bg-light rounded-3">
                <i className="bi bi-check-circle text-success fs-1"></i>
                <p className="mt-2 text-muted mb-0">
                    {selectedCategory ? `تم تحميل جميع المقالات في ${selectedCategory.name}` : 'تم تحميل جميع المقالات'}
                </p>
            </div>
        )}
    </>
);

export default PostsStatusMessages;
